import type { DevelopmentStatus, TaskKind, TaskPriority, TaskRecord, TaskStatus } from "../types";

export const STATUS_LABEL: Record<TaskStatus, string> = {
	todo: "待办",
	in_progress: "进行中",
	done: "已完成",
	closed: "已关闭",
};

/** A development ticket's lifecycle (ADR-0073), which its evidence moves and nobody sets. */
export const DEVELOPMENT_STATUS_LABEL: Record<DevelopmentStatus, string> = {
	undefined: "未定义",
	ready: "就绪",
	in_progress: "进行中",
	ready_to_deploy: "准备部署",
	completed: "已完成",
};

export const KIND_LABEL: Record<TaskKind, string> = {
	ordinary: "普通任务",
	development: "开发任务",
};

export const PRIORITY_LABEL: Record<TaskPriority, string> = {
	low: "低",
	medium: "中",
	high: "高",
};

export const STATUSES = Object.keys(STATUS_LABEL) as TaskStatus[];
export const DEVELOPMENT_STATUSES = Object.keys(DEVELOPMENT_STATUS_LABEL) as DevelopmentStatus[];
export const PRIORITIES = Object.keys(PRIORITY_LABEL) as TaskPriority[];
export const KINDS = Object.keys(KIND_LABEL) as TaskKind[];

/** A task's state as its kind names it. */
export function statusLabel(task: Pick<TaskRecord, "kind" | "status">): string {
	if (task.kind === "development") return DEVELOPMENT_STATUS_LABEL[task.status as DevelopmentStatus] ?? task.status;
	return STATUS_LABEL[task.status as TaskStatus] ?? task.status;
}

const DEVELOPMENT_PILL: Record<DevelopmentStatus, string> = {
	undefined: "pill",
	ready: "pill pill-accent",
	in_progress: "pill tone-run",
	ready_to_deploy: "pill tone-act",
	completed: "pill tone-ok",
};

const TASK_PILL: Record<TaskStatus, string> = {
	todo: "pill",
	in_progress: "pill pill-accent",
	done: "pill tone-ok",
	closed: "pill",
};

/** The pill a task's state wears: waiting for the person stands out, under way and done are coloured, the rest plain. */
export function statusPill(task: Pick<TaskRecord, "kind" | "status">): string {
	return (task.kind === "development" ? DEVELOPMENT_PILL[task.status as DevelopmentStatus] : TASK_PILL[task.status as TaskStatus]) ?? "pill";
}

/** Whether no agent picked the development ticket up yet, so its requirements and kind can still change. */
export const unpicked = (task: TaskRecord) => task.kind !== "development" || task.status === "undefined" || task.status === "ready";
